import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e54d887&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=2e54d887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54d887",
  null
  
)

export default component.exports